import { Component, ViewChild } from '@angular/core';
import { PaymentMethodsFormComponent } from '../payment-methods-form/payment-methods-form.component';

/**
 * The payment method visibility/ordering form in a dialog, opened from the
 * payment form's "Manage" card so studios can tweak methods without leaving
 * the payment they're entering. The save button lives in mat-dialog-actions
 * per the app's dialog convention.
 */
@Component({
  selector: 'app-payment-methods-dialog',
  templateUrl: './payment-methods-dialog.component.html'
})
export class PaymentMethodsDialogComponent {
  @ViewChild(PaymentMethodsFormComponent) form: PaymentMethodsFormComponent;
}
